import { useQuery } from '@tanstack/react-query';

import { getSyncStatus } from '../api/system';

/**
 * 헤더의 '마지막 동기화 시각' 표시용 훅 (의뢰서 4-2).
 * 5분마다 자동 refetch 하여 백그라운드 cron 결과를 반영.
 */
export function useSyncStatus() {
  const { data } = useQuery({
    queryKey: ['system', 'sync-status'],
    queryFn: getSyncStatus,
    refetchInterval: 5 * 60 * 1000,
    staleTime: 60 * 1000,
  });

  return {
    lastSyncedAt: data?.lastSyncedAt ? new Date(data.lastSyncedAt) : null,
  };
}
